.notice { border: 1px solid var(--line); border-left-width: 4px; border-radius: var(--radius); padding: 0.8rem 1rem; background: var(--surface); margin-bottom: var(--space-4); }
.notice > div > :last-child { margin-bottom: 0; }
.title { display: block; margin-bottom: 0.2rem; }
.info { border-left-color: var(--accent); }
.ok { border-left-color: var(--ok); }
.warn { border-left-color: var(--warn); }
.error { border-left-color: var(--danger); }
